import { render, staticRenderFns } from "./caseProfile.vue?vue&type=template&id=717f8b00&scoped=true&"
import script from "./caseProfile.vue?vue&type=script&lang=js&"
export * from "./caseProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f8b00",
  null
  
)

export default component.exports